import React from "react";

const BurgerMenuButton = ({ isOpen, toggle }) => {
  return (
    <button
      onClick={toggle}
      aria-label="Toggle menu"
      className="relative w-6 h-6 flex flex-col justify-between items-center z-50 focus:outline-none"
    >
      <span
        className={`block h-0.5 w-full bg-current rounded transition-all duration-300 ${
          isOpen ? "rotate-45 translate-y-2" : ""
        }`}
      />
      <span
        className={`block h-0.5 w-full bg-current rounded transition-all duration-300 ${
          isOpen ? "opacity-0" : ""
        }`}
      />
      <span
        className={`block h-0.5 w-full bg-current rounded transition-all duration-300 ${
          isOpen ? "-rotate-45 -translate-y-2" : ""
        }`}
      />
    </button>
  );
};

export default BurgerMenuButton;
